import React from 'react'
import { Icon } from 'antd'
import './AudioModeToggle.scss'

const AudioModeToggle = ({ mode, onChange }) => {
  return (
    <div className="audio-mode-toggle">
      <div
        className={`toggle-option ${mode === 'narration' ? 'active' : ''}`}
        onClick={() => onChange({ target: { value: 'narration' } })}
      >
        <Icon
          type="thunderbolt"
          theme={mode === 'narration' ? 'filled' : 'outlined'}
        />
        Narration
      </div>
      <div
        className={`toggle-option ${mode === 'dialogue' ? 'active' : ''}`}
        onClick={() => onChange({ target: { value: 'dialogue' } })}
      >
        <Icon
          type="setting"
          theme={mode === 'dialogue' ? 'filled' : 'outlined'}
        />
        Dialogue
      </div>
      <div className={`toggle-slider ${mode}`} />
    </div>
  )
}

export default AudioModeToggle
